<template>
    <div
      class="bxp-expansion-pane" :class="elClasses"
    >

      <!-- Content -->
      <slot>
      </slot>
      <!-- END Content -->

      <!-- Expand + Collapse toggles -->
      <div v-if="active" @click="toggle()">
        <div class="bxp-toggle" v-if="isCollapsed" >
          <slot name="expand">

          </slot>
        </div>
        <div class="bxp-toggle" v-else>
          <slot name="collapse">
            
          </slot>
        </div>
      </div>
      <!-- END Expand + Collapse toggles -->

    </div>
</template>

<script>
export default {
  props: [
    'mobileOnly',
    'collapsedHeight',
    'collapsed'
  ],
  data() {
    return {
      id: null,
      mounted: false,
      isCollapsed: this.collapsed ? true : false
    }
  },
  computed: {
    active() {
      if (this.mounted && this.$el.scrollHeight > 0 && this.isExpandable() === false) {
        return false
      }
      //Only active on mobile if mobileOnly set
      if (this.mobileOnly || this.mobileOnly === '') {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            return true
          break
          default:
            return false
        }
      }
      return true
    },
    elClasses() {
      return (
        (this.isCollapsed ? '' : 'open') +
        (this.active ? '' : ' inactive')
      )
    }
  },
  methods: {
    toggle() {
      if(this.isCollapsed) {
        this.expandSection()
      } else {
        this.collapseSection()
      }
    },

    collapseSection() {
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = this.$el.scrollHeight;
      
      // temporarily disable all css transitions
      var elementTransition = this.$el.style.transition;
      this.$el.style.transition = '';
      
      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we 
      // aren't transitioning out of 'auto'
      window.requestAnimationFrame(() => {
        this.$el.style.maxHeight = sectionHeight + 'px';
        this.$el.style.transition = elementTransition;
        
        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        window.requestAnimationFrame(() => {
          this.$el.style.maxHeight = this.collapsedHeight;
        });
      });
      
      // mark the section as "currently collapsed"
      this.isCollapsed = true
    },

    expandSection() {
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = this.$el.scrollHeight;

      //Prevent bugs when changing tabs and the element height gets set to 0
      if (sectionHeight === 0) return
      
      // have the element transition to the height of its inner content
      this.$el.style.maxHeight = sectionHeight + 'px';

      // when the next css transition finishes (which should be the one we just triggered)
      let callback = (e) => {
        // remove this event listener so it only gets triggered once
        this.$el.removeEventListener('transitionend', callback);
        // remove "height" from the element's inline styles, so it can return to its initial value
        this.$el.style.maxHeight = null;
      }
      this.$el.addEventListener('transitionend', callback);
      
      // mark the section as "currently not collapsed"
      this.isCollapsed = false
    },

    isExpandable() {
      let pixelHeight = this.collapsedHeight
      if (this.collapsedHeight.indexOf('vh') > -1) {
        pixelHeight = this.vhToPx(this.collapsedHeight)
      }
      return this.$el.scrollHeight > pixelHeight
    },

    //Helper function to convert vh to px
    vhToPx(value) {
      value = value.replace('vh', '')
      var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight|| e.clientHeight|| g.clientHeight;

      var result = (y*value)/100;
      return result;
    }

  },
  mounted() {
    //No need to collapse or expand if the element height 
    //is less than the specified collapsed height
    this.mounted = true

    //Set the initial max height
    if (this.active && this.isCollapsed) {
      var section = this.$el
      section.style.maxHeight = this.collapsedHeight
    }
  },
  watch: {
    //When the screen size changes, collapse or expand accordingly
    active(isActive) {
      if (isActive) {
        this.collapseSection()
      } else {
        this.expandSection()
      }
    }
  }
}
</script>

<style scoped>
    
  .bxp-expansion-pane {
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
    max-height: auto;
    position: relative;
    margin-bottom: 32px;
  }

  .bxp-expansion-pane:not(.inactive):before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 120px;
    z-index: 2;
    background: linear-gradient(0deg, rgba(255,255,255,1) 50%, transparent 100%);
    transition: opacity 0.5s ease-in-out;
  }

  .bxp-expansion-pane.open:before {
    opacity: 0;
  }

  .bxp-toggle {
    position: absolute;
    bottom: 0;
    z-index: 3;
    text-align: center;
    width: 100%;
  }

  .bxp-toggle:hover {
    cursor:pointer
  }

  @media (max-width: 1032px) {
    .bxp-expansion-pane {
      padding-bottom: 24px;
    }
  }

</style>